(function(){
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};

  /* menu */
  var burger=$('#burger'), nav=$('#nav');
  burger&&burger.addEventListener('click',function(){
    var on=nav.classList.toggle('on'); burger.setAttribute('aria-expanded',String(on));
  });

  /* product options — the select stays the source of truth for the form */
  var sel=$('#vsel');
  if(sel){
    $$('.opt').forEach(function(b){
      b.addEventListener('click',function(){
        if(b.disabled) return;
        $$('.opt').forEach(function(x){x.classList.remove('opt--on')});
        b.classList.add('opt--on');
        sel.value=b.dataset.vid;
        var p=$('#pprice'); if(p&&b.dataset.price) p.textContent=b.dataset.price;
        var add=$('#addbtn');
        if(add){ var ok=b.dataset.available==='true';
          add.disabled=!ok; add.textContent=ok?'Add to cart':'Sold out'; }
      });
    });
  }

  /* cart quantities — repaint from the response, never reload.
     A reload cancels the request that caused it, which is how a typed quantity
     ends up only half applied. */
  var busy={};
  function money(c){return '$'+(c/100).toFixed(2)}
  function setQty(key,q){
    if(busy[key]) return; busy[key]=true;
    fetch('/cart/change.js',{method:'POST',credentials:'same-origin',
      headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Math.max(0,q)})})
      .then(function(r){return r.json()}).then(function(cart){
        var live={}; cart.items.forEach(function(i){live[i.key]=i});
        $$('[data-line]').forEach(function(row){
          var it=live[row.dataset.line];
          if(!it){row.remove();return}
          var lp=$('[data-lineprice]',row); if(lp) lp.textContent=money(it.line_price);
          var qi=$('[data-qty]',row); if(qi) qi.value=it.quantity;
        });
        var t=$('[data-carttotal]'); if(t) t.textContent=money(cart.total_price);
        if(!cart.items.length) location.reload();
      })["catch"](function(){})
      ["finally"](function(){busy[key]=false});
  }
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-step]'); if(!b) return;
    e.preventDefault();
    var row=b.closest('[data-line]'), i=$('[data-qty]',row);
    var n=(parseInt(i.value,10)||0)+parseInt(b.dataset.step,10);
    if(n<0) return; i.value=n; setQty(b.dataset.key,n);
  });
  document.addEventListener('change',function(e){
    var i=e.target.closest('[data-qty]'); if(!i) return;
    var n=parseInt(i.value,10); if(isNaN(n)||n<0){n=0;i.value=0}
    setQty(i.dataset.qty,n);
  });
  document.addEventListener('keydown',function(e){
    if(e.key!=='Enter') return;
    var i=e.target.closest('[data-qty]'); if(!i) return;
    e.preventDefault(); i.blur();     /* Enter would submit the form and lose the value */
  });

  /* the guide — live search across guides AND products.
     Predictive Search, not a client-side index: blog.articles caps at 50 in an
     unpaginated loop and this blog has more than that. */
  var q=$('[data-hub-q]');
  if(q){
    var res=$('[data-hub-res]'), st=$('[data-hub-status]'), cl=$('[data-hub-clear]'),
        lib=$('[data-hub-lib]'), t=null, seq=0;
    var esc=function(s){return String(s).replace(/[&<>"']/g,function(c){
      return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]})};
    function reset(){res.hidden=true;res.innerHTML='';st.textContent='';cl.hidden=true;if(lib)lib.hidden=false}
    function run(){
      var v=q.value.trim(); cl.hidden=!v;
      if(v.length<2){reset();return}
      var mine=++seq; st.textContent='Searching…';
      fetch('/search/suggest.json?q='+encodeURIComponent(v)+'&resources[type]=article,product&resources[limit]=8',
        {credentials:'same-origin'}).then(function(r){return r.json()}).then(function(j){
          if(mine!==seq) return;
          var r0=(j.resources&&j.resources.results)||{}, a=r0.articles||[], p=r0.products||[];
          var html=p.map(function(x){return '<a href="'+esc(x.url)+'"><b>'+esc(x.title)+'</b><span>In the shop</span></a>'}).join('')
                 + a.map(function(x){return '<a href="'+esc(x.url)+'"><b>'+esc(x.title)+'</b></a>'}).join('');
          if(lib) lib.hidden=!!html;
          res.hidden=false;
          res.innerHTML=html||'<a href="/search?q='+encodeURIComponent(v)+'"><b>Nothing matched “'+esc(v)+'”</b><span>Try kosher, gummies, CBN, topical</span></a>';
          var bits=[];
          if(p.length) bits.push(p.length+(p.length===1?' product':' products'));
          if(a.length) bits.push(a.length+(a.length===1?' guide':' guides'));
          st.textContent=bits.length?bits.join(' and ')+' matching “'+v+'”':'No matches for “'+v+'”';
        })["catch"](function(){if(mine===seq)st.textContent='Search is unavailable right now.'});
    }
    q.addEventListener('input',function(){clearTimeout(t);t=setTimeout(run,220)});
    cl.addEventListener('click',function(){q.value='';reset();q.focus()});
    q.form&&q.form.addEventListener('submit',function(e){e.preventDefault();run()});
  }
})();

/* A table typed into a page or an article is whatever width the person who
   typed it happened to make it. Wrap each one so the TABLE scrolls and the
   page never does. tabindex+role make the scroller reachable by keyboard,
   which is required once a region scrolls. */
document.querySelectorAll('.rte table').forEach(function (t) {
  if (t.closest('.tscroll')) return;
  var w = document.createElement('div');
  w.className = 'tscroll';
  w.setAttribute('tabindex', '0');
  w.setAttribute('role', 'region');
  w.setAttribute('aria-label', 'Table, scrolls sideways');
  t.parentNode.insertBefore(w, t);
  w.appendChild(t);
});

/* On a phone the full placeholder is cut off mid-word — "Search 62 guides and
   every pr…" — which reads as a broken field rather than a hint. A placeholder
   cannot be changed by CSS, so the short version is swapped in on narrow
   screens and back out if the window grows. */
(function () {
  var q = document.querySelector('[data-short]');
  if (!q) return;
  var full = q.getAttribute('placeholder'), short = q.getAttribute('data-short');
  var fit = function () { q.setAttribute('placeholder', window.innerWidth < 620 ? short : full); };
  fit();
  window.addEventListener('resize', fit);
})();
